export enum ContentoAccessibilities {
    AUDIO_DESCRIBED = 'AudioDescribed',
    SIGN_INTERPRETED = 'SignInterpreted',
    DEFAULT = 'Default',
}

export default ContentoAccessibilities;
